<script setup>
import {provide} from "vue";

const props = defineProps({
    wizard: {
        type: Object,
        required: true,
    },
});

provide('wizard', props.wizard);
</script>

<template>
    <nav class="wizard-progress">
        <slot></slot>
    </nav>
</template>
